import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import { STRONGHOLD } from 'urls'

import { KEY_CODES } from 'constants'

import { Button, Tooltip } from 'react-wot-bootstrap'

import LackOfIndustrialResource from 'components/LackOfIndustrialResource/LackOfIndustrialResource.jsx'
import Warning from 'components/Warning/Warning.jsx'
import LoadingScreen from 'components/LoadingScreen/LoadingScreen.jsx'
import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'
import Back from 'components/Back/Back.jsx'

import {
    ConstructCarousel,
    ConstructReserve,
    ConstructConfirmation,
} from './components'

import requestAvailableBuildings, {
    selectBuilding,
} from 'state/actions/available_buildings'

import { openConstructConfirmation } from 'state/actions/building_construction'
import { playCarouselHoverSound } from 'state/actions/sounds'

import {
    RESERVE_DESCRIPTIONS,
    CONSTRUCT_HEADERS,
    PERMISSION_WARNING,
    CONSTRUCTION_COST,
    BUILD_BUTTON_CAPTION,
    NOT_ENOUGH_TOOLTIP_ID,
} from './constants.jsx'
import { RESERVE_TITLES } from 'helpers/i18n.jsx'

import styles from './Construct.scss'


export class Construct extends React.Component {
    static propTypes = {
        loaded: PropTypes.bool.isRequired,
        loading: PropTypes.bool.isRequired,
        submitting: PropTypes.bool.isRequired,
        submitted: PropTypes.bool.isRequired,
        confirmationOpened: PropTypes.bool.isRequired,
        slotId: PropTypes.number.isRequired,
        buildings: PropTypes.arrayOf(PropTypes.object),
        selectedBuildingIdx: PropTypes.number.isRequired,
        hasPermission: PropTypes.bool.isRequired,
        clanIndustrialResource: PropTypes.number.isRequired,
        settings: PropTypes.object.isRequired,

        selectBuilding: PropTypes.func.isRequired,
        openConstructConfirmation: PropTypes.func.isRequired,
        requestAvailableBuildings: PropTypes.func.isRequired,
        playCarouselHoverSound: PropTypes.func.isRequired,
        pushState: PropTypes.func.isRequired,
    }
    constructor(props) {
        super(props)
        this.selectHandler = index => this.props.selectBuilding(index)
        this.backHandler = props.pushState.bind(null, STRONGHOLD)
        this.onKeyUp = this.onKeyUp.bind(this)
        this.handleBuildButtonClick = props.openConstructConfirmation
    }
    onKeyUp(e) {
        if (e.keyCode === KEY_CODES.ESCAPE && !this.props.confirmationOpened) {
            this.backHandler()
        }
    }
    componentWillMount() {
        this.props.requestAvailableBuildings()
        window.addEventListener('keydown', this.onKeyUp)
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyUp)
    }
    componentWillReceiveProps(nextProps) {
        // if there no available buildings had been returned send user back to stronghold
        // here we asssume that user will receive update with new building by websocket
        if (nextProps.buildings.length === 0 && nextProps.loaded) {
            this.props.pushState(STRONGHOLD)
        }

        if (!this.props.submitted && nextProps.submitted) {
            this.props.pushState(STRONGHOLD)
        }
    }
    render() {
        const loadingScreen = <LoadingScreen />
        let component
        if (this.props.loading || !this.props.loaded) {
            component = loadingScreen
        } else {
            if (this.props.buildings.length === 0) return null

            const { building } = this.props.buildings[this.props.selectedBuildingIdx]
            const reserveType = this.props.settings.buildings[building.type].reserve_type
            const reserveInfo = this.props.settings.reserves[reserveType]
            const hasEnoughIndustrialResource = this.props.clanIndustrialResource >= building.cost
            const title = this.props.hasPermission ? CONSTRUCT_HEADERS.title : CONSTRUCT_HEADERS.title_no_permission

            const constructCost = (
                <p className={styles.cost} data-tip data-for={NOT_ENOUGH_TOOLTIP_ID}>
                    {CONSTRUCTION_COST}
                    <IndustrialResource value={building.cost} notEnough={!hasEnoughIndustrialResource}/>
                </p>
            )

            let constructFooter
            if (this.props.hasPermission) {
                let tooltip
                if (!hasEnoughIndustrialResource) {
                    const industrialResource = (
                        <IndustrialResource
                            value={building.cost - this.props.clanIndustrialResource}
                            notEnough={false}
                            small
                        />
                    )

                    tooltip = (
                        <Tooltip id={NOT_ENOUGH_TOOLTIP_ID}>
                            <LackOfIndustrialResource resource={industrialResource} />
                        </Tooltip>
                    )
                }

                constructFooter = (
                    <div>
                        <Button
                            onClick={this.handleBuildButtonClick}
                            isDisabled={!hasEnoughIndustrialResource}
                            tooltipId={!hasEnoughIndustrialResource ? NOT_ENOUGH_TOOLTIP_ID : null}
                        >
                            {BUILD_BUTTON_CAPTION}
                        </Button>
                        <ConstructConfirmation slotId={this.props.slotId} building={building} />
                        {tooltip}
                    </div>
                )
            } else {
                constructFooter = (
                    <div className={styles.warning}>
                        <Warning>
                            {PERMISSION_WARNING}
                        </Warning>
                    </div>
                )
            }

            component = (
                <div className={styles.holder}>
                    <div className={styles.header}>
                        <div className='contstruct_centered'>
                            <div className={styles.titleWrapper}>
                                <div className={styles.back}>
                                    <Back handleClick={this.backHandler} />
                                </div>
                                <h1 className={styles.title}>{title}</h1>
                            </div>
                        </div>
                    </div>

                    <div className={styles.main}>
                        <div className={styles.centered}>
                            <ConstructCarousel
                                onItemClick={this.selectHandler}
                                onItemHover={this.props.playCarouselHoverSound}
                                selectedBuildingIdx={this.props.selectedBuildingIdx}
                                buildings={this.props.buildings}
                            />

                            <ConstructReserve
                                name={RESERVE_TITLES[reserveInfo.type]}
                                type={reserveInfo.type}
                                description={RESERVE_DESCRIPTIONS[reserveInfo.type]}
                                bonus={reserveInfo.bonus}
                            />
                        </div>
                    </div>

                    <div className={styles.footer}>
                        <div>
                            {constructCost}
                            {constructFooter}
                        </div>
                    </div>
                    {this.props.submitting ? loadingScreen : null}
                </div>
           )
        }

        return (
            <div className={styles.base}>
                {component}
            </div>
        )
    }
}

export const mapStateToProps = (state, ownProps) => {
    const slotId = parseInt(ownProps.params.slotId)
    const { account, clan, settings } = state
    const { loading, loaded, buildings, selectedBuildingIdx } = state.availableBuildings
    const { submitting, submitted } = state.buildingConstruction
    const clanIndustrialResource = clan ? clan.industrial_resource : 0
    const hasPermission = (account.permissions.manage_building === true)
    const confirmationOpened = state.buildingConstruction.confirmationOpened
    return {
        slotId,
        buildings,
        selectedBuildingIdx,
        loading,
        loaded,
        submitting,
        submitted,
        clanIndustrialResource,
        hasPermission,
        settings,
        confirmationOpened,
    }
}

export const mapDispatchToProps = {
    requestAvailableBuildings,
    selectBuilding,
    openConstructConfirmation,
    playCarouselHoverSound,
    pushState: push,
}

export default connect(mapStateToProps, mapDispatchToProps)(Construct)



// WEBPACK FOOTER //
// ./containers/Construct/Construct.jsx